import { styled } from "styled-components";

export const ToolbarContentStyled = styled.div``

export const ToolbarStyled = styled.div``
